import Notify from "@Components/notify/Notify.vue";

export default function defaultNotify() {
  return {
    component: Notify,
    type: "error",
    title: "Invalid",
    text: __("something_went_wrong"),
    duration: 5000,
  };
}
